// src/pages/DynamicLoginRoute.tsx
import React from 'react';
import { useAuth } from '../Auth';
import App from '../App';
import PortalHeader from '../client-dashboard/clientNavbar/PortalHeader';
import Login2 from '../pages/LoginFolder/Login';

const DynamicLoginRoute: React.FC = () => {
  const { isAuthenticated } = useAuth();

  return (
    <>
      {isAuthenticated ? (
        <>
          <PortalHeader />
          <Login2 />
        </>
      ) : (
        <App>
          <Login2 />
        </App>
      )}
    </>
  );
};

export default DynamicLoginRoute;
